import { createSlice } from "@reduxjs/toolkit";
import { useAppSelector } from "screens/Root/hooks/useAppSelector";
const initialState = {
    openKeys: [],
};
export const getLevelFromId = (id) => {
    const level = id.split("-")[0];
    return parseInt(level === "rc" ? "0" : level);
};
const getMenusWithLowerLevel = (state, key) => {
    const level = getLevelFromId(key);
    const menusLowerLevel = state.openKeys.filter((x) => getLevelFromId(x) < level);
    return menusLowerLevel;
};
const closeMenuInternal = (state, action) => {
    const key = action.payload;
    if (!key) {
        state.openKeys = [];
        return;
    }
    const menusBeforeLevel = getMenusWithLowerLevel(state, key);
    state.openKeys = menusBeforeLevel.filter((x) => x !== key);
};
const openMenuInternal = (state, action) => {
    const key = action.payload;
    if (state.openKeys.includes(key)) {
        return;
    }
    const menusBeforeLevel = getMenusWithLowerLevel(state, key);
    state.openKeys = [...menusBeforeLevel, key];
};
const slice = createSlice({
    name: "TopMenu",
    initialState,
    reducers: {
        openMenu: openMenuInternal,
        closeMenu: closeMenuInternal,
        toggleMenu: (state, action) => {
            const isOpen = state.openKeys.includes(action.payload);
            const operation = isOpen ? closeMenuInternal : openMenuInternal;
            operation(state, action);
        },
    },
});
export const { openMenu, closeMenu, toggleMenu } = slice.actions;
export const useTopMenuState = () => useAppSelector((state) => state.topMenu);
export default slice.reducer;
